import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import "./App.css";
import App from "./App";
import AuthenticatedApp from "./AuthenticatedApp";
import { oidcConfig, oidcEnabled } from "./auth";
import DesignConceptPreview from "./DesignConceptPreview";
import LocalAccessPreview from "./LocalAccessPreview";

const root = ReactDOM.createRoot(document.getElementById("root"));
const isDesignPreview = process.env.NODE_ENV !== "production"
	&& new URLSearchParams(window.location.search).has("design-preview");
const isAuthPreview = process.env.NODE_ENV !== "production"
	&& new URLSearchParams(window.location.search).has("auth-preview");
const isAccessPreview = process.env.NODE_ENV !== "production"
	&& new URLSearchParams(window.location.search).has("access-preview");

if (isAccessPreview) {
	window.fetch = () => Promise.reject(new Error("Network requests are disabled in the local access preview."));
}

const content = isAccessPreview
	? <React.StrictMode><LocalAccessPreview /></React.StrictMode>
	: isDesignPreview
	? <React.StrictMode><DesignConceptPreview /></React.StrictMode>
	: isAuthPreview
	? <React.StrictMode><App profileName="Local preview" profileEmail={process.env.REACT_APP_FEEDBACK_ADMIN_EMAILS?.split(",")[0] || "local-preview@example.com"} onSignOut={() => {
		const url = new URL(window.location.href);
		url.searchParams.delete("auth-preview");
		window.location.assign(url);
	}} /></React.StrictMode>
	: oidcEnabled
	? (
		<AuthProvider {...oidcConfig}>
			<React.StrictMode>
				<AuthenticatedApp />
			</React.StrictMode>
		</AuthProvider>
	)
	: process.env.NODE_ENV === "production"
		? <main className="auth-config-error">Ping ID is not configured for this production build.</main>
		: <React.StrictMode><App /></React.StrictMode>;

root.render(content);
